module.exports = __webpack_public_path__ + "img/1013380.904d7e8a.jpg";